import React, { Component, Fragment } from "react";
import queryString from "query-string";
import LibrarySetup from "./librarySetup";
import "../../assets/scss/pages/app-library.scss";
import "../../assets/scss/pages/common.scss";
import Breadcrumbs from "../../theme/@vuexy/breadCrumbs/BreadCrumb";

const mql = window.matchMedia(`(min-width: 992px)`)
import { inject, observer } from 'mobx-react';

class LibraryApp extends Component {
  state = {
    sidebarDocked: mql.matches,
    sidebarOpen: false
  }

  UNSAFE_componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen = open => {
    this.setState({ sidebarOpen: open });
  }

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
  }

  render() {
    return (
      <Fragment>
        {/* <Breadcrumbs
          breadCrumbTitle="Library"
          breadCrumbParent="My Documents"
          breadCrumbActive="Presentations"
        /> */}
        <LibrarySetup
          sidebarOpen={this.state.sidebarOpen}
          sidebarDocked={this.state.sidebarDocked}
          onSetSidebarOpen={(value)=>this.onSetSidebarOpen(value)}
          hasShareableFunctionality={true}
          hasEditableFunctionality={true}
          hasAddNewFunctionality={true}
         />
      </Fragment>
    )
  }
}

export default LibraryApp;
